import { useCallback } from "react";
import { getOffsetParameterValue } from "../../../evergis/core/classification/classifyOffset";
import { getParameterValue } from "../../../evergis/core/classification/getFromClassified";
import { AngleSymbolTypes, CalculatedAble, SimpleOffset, StyleSymbolType } from "../../../interfaces/style";
import { shallowEqual } from "../../../utils/shallowEqual";

const rotateOffset = ([x, y]: SimpleOffset, angle: number) => {
  const sin = Math.sin(angle);
  const cos = Math.cos(angle);

  const offset: SimpleOffset = [Math.round(x * cos - y * sin), Math.round(x * sin + y * cos)];

  return offset;
};

const pathSymbolWithOffsetUpdate = <S extends AngleSymbolTypes>(symbol: S, update: Partial<AngleSymbolTypes>): S => {
  if (symbol.offset && symbol.angle !== undefined) {
    const prevAngle = getParameterValue<number>(symbol.angle);
    const currAngle = getParameterValue<number>(update.angle === undefined ? prevAngle : update.angle);
    const fixedOffset = getOffsetParameterValue(symbol.offset);
    const nextOffset = rotateOffset(rotateOffset(fixedOffset, -prevAngle), currAngle);

    if (!shallowEqual(symbol.offset, nextOffset)) {
      return {
        ...symbol,
        ...update,
        offset: nextOffset,
      };
    }
  }

  return {
    ...symbol,
    ...update,
  };
};

export const useAngleChange = <S extends AngleSymbolTypes>(symbol: S, onChange: (symbol: StyleSymbolType) => void) =>
  useCallback(
    (angle: CalculatedAble<number>) => {
      onChange(pathSymbolWithOffsetUpdate(symbol, { angle }));
    },
    [symbol, onChange],
  );
